import React, { useEffect } from 'react';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { Box, Chip, Skeleton, Stack, styled } from '@mui/material';
import { TreeItem, treeItemClasses } from '@mui/x-tree-view/TreeItem';
import AddBoxIcon from '@mui/icons-material/AddBox';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import useGroupUpdate from '../../hooks/site/useGroupUpdate';
import { ENUM_CUS_EVENT } from '../../enums/enums';
import { dispatchCusEvent } from '../../utils';
import { useAppSelector } from '../../store';
import { IconLock, IconUser } from '@tabler/icons-react';
import ShowContainer from '../../components/material-ui/ShowContainer';
import GroupChildren from './GroupChildren';

export default function ThreeGroup({
  chooseGroupId,
  setChooseGroupeId,
  expandedItems,
  selectedItems,
  setSelectedItems,
  setClickedGroupId,
  isManualUpdate,
  setExpandedItems,
  isHighlight,
  viewId
}) {
  useGroupUpdate(chooseGroupId, setChooseGroupeId, isManualUpdate);

  const mainGroup = useAppSelector((state) => state.user.group.main);
  const groupHash = useAppSelector((state) => state.user.group.hash);

  const defaultItem = mainGroup?.groupId;

  useEffect(() => {
    if (isManualUpdate) return;
    dispatchCusEvent(ENUM_CUS_EVENT.getGroupData, { groupId: chooseGroupId });
  }, [chooseGroupId, isManualUpdate]);

  return (
    <ShowContainer condition={defaultItem}>
      <SimpleTreeView
        defaultExpandedItems={[String(defaultItem)]}
        defaultSelectedItems={[String(defaultItem)]}
        expandedItems={expandedItems}
        selectedItems={selectedItems}
        onSelectedItemsChange={setSelectedItems ? (_, val) => setSelectedItems(val) : undefined}
        onExpandedItemsChange={setExpandedItems ? (_, val) => setExpandedItems(val) : undefined}
        slots={{
          expandIcon: AddBoxIcon,
          collapseIcon: IndeterminateCheckBoxIcon,
          endIcon: IconUser
        }}>
        <GroupChildren
          setClickedGroupId={setClickedGroupId}
          setChooseGroupeId={setChooseGroupeId}
          key={mainGroup.groupId}
          viewId={viewId}
          gamerCount={mainGroup.gamerCount}
          groupId={mainGroup.groupId}
          isLocked={mainGroup.locked}
          groupName={mainGroup.name}
          isGame={mainGroup.game}
          isHighlight={isHighlight}
          casinoId={mainGroup.casinoId}
        />
      </SimpleTreeView>
    </ShowContainer>
  );
}
